import req from './RequestService'

const AttachmentService = {
    getFile: (fileId, options) => req.getFile(`files/${fileId}`, options),
}
export default AttachmentService;
